import { initAccordion } from './features/accordion.js';
import { initBannerSlider } from './features/banner-slider.js';
import { initBottomFillTextareas } from './features/bottom-fill-textarea.js';
import { initContactLettersCanvas } from './features/contact-letters-canvas.js';
import { initFormValidation } from './features/form-validation.js';
import { initFooterYear } from './features/footer-year.js';
import { initGlobalFadeIn } from './features/global-fade-in.js';
import { initIntroOverlay } from './features/intro-overlay.js';
import { initNavMenuScrollLock } from './features/nav-menu-scroll-lock.js';
import { initNavbarThemeSections } from './features/navbar-theme.js';
// import { initPortfolioSlider } from './features/portfolio-slider.js';
import { initTabs } from './features/tabs.js';
import { initTemplateRichLayouts } from './features/template-rich-layout.js';
import { initViewTransitionOverlay } from './features/view-transition-overlay.js';
import { loadGsap, loadScrollTrigger } from './shared/animation-loader.js';

export const bootstrap = async () => {
  initViewTransitionOverlay();
  initFooterYear();
  initGlobalFadeIn();
  initNavMenuScrollLock();
  initBottomFillTextareas();
  initContactLettersCanvas();
  initFormValidation();

  const richTexts = document.querySelectorAll('.template__rich');

  if (richTexts.length) {
    initTemplateRichLayouts(richTexts);
  }
  document.querySelectorAll('[data-animate-init]').forEach(el => el.classList.add('is-visible'));

  const gsap = await loadGsap();
  const ScrollTrigger = await loadScrollTrigger(gsap);

  document.querySelectorAll('.section__intro-track').forEach((track) => {
    initIntroOverlay(track, ScrollTrigger);
  });

  initNavbarThemeSections(ScrollTrigger);

  document.querySelectorAll('.content__tabs').forEach((tabs) => {
    initTabs(tabs, gsap);
  });

  document.querySelectorAll('.banner__slider-track').forEach((track) => {
    initBannerSlider(track, gsap, ScrollTrigger);
  });

  // document.querySelectorAll('.portfolio__slider').forEach((slider) => {
  //   initPortfolioSlider(slider, gsap);
  // });

  document.querySelectorAll('.content__accordion-track').forEach((track) => {
    initAccordion(track, ScrollTrigger);
  });
};
